import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; // @ts-check

import React from 'react';
import FilterTopNDialog from './FilterTopNDialog';
import ToggleIcon from '../ToggleIcon';

var DimensionFilter = function DimensionFilter(_ref) {
  var filters = _ref.filters,
      _onChange = _ref.onChange,
      disabled = _ref.disabled;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      filterOpen = _React$useState2[0],
      setFilterOpen = _React$useState2[1];

  return React.createElement(React.Fragment, null, React.createElement(ToggleIcon, {
    type: "filter",
    label: "Filter",
    disabled: disabled,
    checked: filters.length > 0,
    onClick: function onClick() {
      return setFilterOpen(true);
    },
    style: {
      fontSize: 24
    }
  }), filterOpen && React.createElement(FilterTopNDialog, {
    onClose: function onClose() {
      return setFilterOpen(false);
    },
    filter: filters[0],
    onChange: function onChange(filter) {
      return _onChange([filter]);
    },
    onRemove: function onRemove() {
      _onChange([]);

      setFilterOpen(false);
    }
  }));
};

export default DimensionFilter;